// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"edda780f","720":"ae7b985c"}[chunkId] + ".chunk.js";
};